import React from "react";
import { PlusIcon } from "lucide-react";

// Native <details>/<summary>: keyboard accessible, answers present in HTML, maps to native Bricks elements.
type FaqItem = {
  question: string;
  answer: string;
};
type FaqAccordionProps = {
  items: FaqItem[];
};
export function FaqAccordion({
  items
}: FaqAccordionProps) {
  return <div className="space-y-3" data-id="element-543" data-mp="1es4zeuy0kb32">
      {items.map(item => <details key={item.question} className="group rounded-[20px] border border-line bg-white transition-[border-color,box-shadow] duration-200 ease-out open:border-charcoal/30 open:shadow-[0_16px_32px_-24px_rgba(43,39,39,0.4)] hover:border-charcoal/30" data-id="element-544" data-mp="2bhm3j5hclp2n">
          <summary className="flex cursor-pointer items-center justify-between gap-6 rounded-[20px] px-6 py-5 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ocean md:px-7" data-id="element-545" data-mp="1xppifle3kffr">
            <span className="font-heading text-[17px] font-semibold text-charcoal md:text-[19px]" data-id="element-546" data-mp="2qemvna3gbm1n">{item.question}</span>
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-paper transition-colors duration-200 ease-out group-open:bg-ocean" data-id="element-547" data-mp="1fik1w0za7t2q">
              <PlusIcon className="h-4 w-4 text-charcoal transition-transform duration-200 ease-out group-open:rotate-45" aria-hidden="true" data-id="element-548" data-mp="16qi3074v2kuk" />
            </span>
          </summary>
          <p className="px-6 pb-6 text-[17px] leading-relaxed text-slate md:px-7" data-id="element-549" data-mp="1aq0n50ouyrwc">{item.answer}</p>
        </details>)}
    </div>;
}